<h2 mat-dialog-title>{{'Edit Status' | translate}}</h2>

<form [formGroup]="volunteerStatusForm">
  <div mat-dialog-content>
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
      <mat-form-field appearance="outline" style="width: 45%;">
        <mat-label>{{'Full Name' | translate}}</mat-label>
        <input [disabled]="true" [readonly]="true" formControlName="fullName" matInput type="text"/>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%;">
        <mat-label>{{'Status' | translate}}</mat-label>
        <mat-select formControlName="status"
        >
          <mat-option *ngFor="let status of statuses" [disabled]="data.volunteers.status === 'REJECTED'"
                      [value]="status">{{ status }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div mat-dialog-actions style="display: flex; justify-content: space-around">
      <button (click)="cancel()" class="loginBtn" color="primary" mat-raised-button>{{'Cancel'| translate}}</button>
      <button (click)="updateStatus()"
              [disabled]="loading || data.volunteers.status === 'ACCEPTED' || data.volunteers.status === 'REJECTED'"
              class="loginBtn" color="primary" mat-raised-button type="submit">
        <mat-progress-spinner *ngIf="loading" color="primary" diameter="20" mode="indeterminate"></mat-progress-spinner>
        <span *ngIf="!loading" style="color: white">{{'Update' | translate}}</span>
      </button>
    </div>
  </div>
</form>
